// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import i18n from './i18n'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
import { accessTokenValid, refreshTokenValid } from '@/router/auth'
import { getRefreshToken, getAccessToken, setAccessToken } from '@/utils/cookie'
import { EventBus } from '@/router/bus'
import './configuration'
import '@/mixins/console'
import '@/mixins/helper'
import '@/mixins/export'
import '@/mixins/translator'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import { endpointRequireToken } from './utils/endpoints'
import '@babel/polyfill'
// import * as Sentry from '@sentry/browser'
import { store } from './store'
import router from './router'

Vue.use(BootstrapVue)

Vue.config.productionTip = false
Vue.config.debug = true
Vue.http.options.root = Vue.$config.api_root

// TODO extract into separate file
Vue.http.interceptors.push(function (request, next) {
  const isTokenRequired = Vue.http.headers.common['REFRESH_TOKEN'] !== 'IN_PROGRESS' && endpointRequireToken(request.url)
  Vue.http.headers.common['Content-Type'] = 'application/json'
  if (isTokenRequired) {
    Vue.http.headers.common['Authorization'] = 'Bearer ' + getAccessToken()
    if (!accessTokenValid()) {
      handleInvalidToken(request, next)
      return
    }
  }
  // continue to next interceptor
  next()
})

function handleInvalidToken (request, next) {
  let isProductionEnvironment = process.env.NODE_ENV.toUpperCase() === 'production'.toUpperCase()
  if (!isProductionEnvironment) { console.log('Access token expired - attempting to refresh') }
  if (!refreshTokenValid()) {
    if (!isProductionEnvironment) { console.log('Refresh token no longer valid') }
    router.push('/')
    EventBus.$emit('alert', {
      variant: 'danger',
      message: i18n.t('errors.token.refreshTokenExpired'),
      errors: []
    })
  } else {
    // REFRESH TOKEN
    Vue.http.headers.common['REFRESH_TOKEN'] = 'IN_PROGRESS'
    const refreshTokenUrl = Vue.$apiConfig.loginRefresh
    Vue.http.headers.common['Authorization'] = 'Bearer ' + getRefreshToken()
    Vue.http.get(refreshTokenUrl)
      .then(response => {
        if (!isProductionEnvironment) { console.log('Access token refreshed successfully') }
        setAccessToken(response.data.payload.accessToken)
        Vue.http.headers.common['Authorization'] = 'Bearer ' + response.data.payload.accessToken
        Vue.http.headers.common['REFRESH_TOKEN'] = 'DONE'
        next()
      }, error => {
        Vue.http.headers.common['REFRESH_TOKEN'] = 'DONE'
        if (!isProductionEnvironment) { console.log('Failed to obtain new access token after refresh: ' + error) }
        router.push('/')
        let errorMessage = ''
        if (error.status === 0) {
          errorMessage = i18n.t('apiStatusCodes.0')
        } else {
          errorMessage = i18n.t('errors.token.failedToRefreshToken')
        }
        EventBus.$emit('alert', {
          variant: 'danger',
          message: errorMessage,
          errors: []
        })
      })
  }
}

if (process.env.NODE_ENV.toUpperCase() !== 'local'.toUpperCase()) {
  // Sentry.init({
  //   dsn: Vue.$config.sentry.dsn,
  //   integrations: [new Sentry.Integrations.Vue({ Vue })],
  //   release: Vue.$config.app_release
  // })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js